import React, { useMemo } from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { getAlternativeStepParameterInitialValues } from "store/rs-workspace/selectors/results.selectors";
import { INPUT } from "shared/labels";
import * as styles from "../../../../styles.module.scss";
const AlternativeStepPreview = ({ parameter }) => {
    const flows = useSelector(getAlternativeStepParameterInitialValues(parameter.parameter));
    const rangeLabel = useMemo(() => flows?.flowsList
        .filter((_, index) => parameter.parameter?.flowIndexes?.includes(index))
        .join(" + "), [flows?.flowsList, parameter.parameter]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(styles.cell, styles.unit) }),
        React.createElement("div", { className: classNames(styles.cell, styles.range) },
            React.createElement("span", { className: styles["preview-value"] }, rangeLabel || INPUT.UNDEFINED)),
        React.createElement("div", { className: classNames(styles.cell, styles.granularity) })));
};
export default AlternativeStepPreview;
